import { render, staticRenderFns } from "./ContactsPlusLogo.vue?vue&type=template&id=0e832f96"
import script from "./ContactsPlusLogo.vue?vue&type=script&lang=js"
export * from "./ContactsPlusLogo.vue?vue&type=script&lang=js"
import style0 from "./ContactsPlusLogo.vue?vue&type=style&index=0&id=0e832f96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports